export default __webpack_public_path__ + "static/media/Juan.bb082683.jpg";